import React from "react";

const IncomeCard = ({ data }) => {
  return (
    <div className="modern_profile_card">
      <div className="header_section">
        <img
          src={imagepaths.walletMoneyIcon}
          alt="walletMoneyIcon"
          className="card_icon"
        />
        <h2 className="title">Income Details</h2>
      </div>
      <div className="body_section">
        <div className="info_row">
          <span className="label">Company Name</span>
          <span className="value">{data?.companyname || "-"}</span>
        </div>
        <div className="info_row">
          <span className="label">Mode of Salary</span>
          <span className="value">{data?.salaryMode || "-"}</span>
        </div>
        <div className="info_row">
          <span className="label">Monthly Salary</span>
          <span className="value">{data?.monthlySalary?.cur() || "-"}</span>
        </div>
        <div className="info_row">
          <span className="label">Office Email</span>
          <span className="value">{data?.officialEmail || "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default constore(IncomeCard);
